// extracted by mini-css-extract-plugin
export var root = "DatePicker-module__root___rWOgb";
export var expandedRoot = "DatePicker-module__expandedRoot___PJuo_";
export var textInput = "DatePicker-module__textInput___e6nX_";
export var popoverRoot = "DatePicker-module__popoverRoot___vDBQ3";
export var slim = "DatePicker-module__slim___HSKnQ";